<template>
	<div
		:class="{ 'bottom-bar': bottomBar }"
		class="explanation-container width-100 display-flex flex-row flex-align-center flex-justify-space-between"
	>
		<div class="empty-button-placeholder" />
		<div>Complete your interface once to create sample data</div>
		<AnemicButton @click="$emit('hide-widget')" class="cancel-button">Cancel</AnemicButton>
	</div>
</template>

<script>
export default {
	name: 'WidgetTestFooter',
	props: {
		bottomBar: { type: Boolean },
	},
};
</script>

<style lang="scss" scoped>
$button-width: 88px;
.explanation-container {
	height: 68px;
	padding: 0px 15px;
	background: var(--bold-border-color);

	font-size: 14px;
	color: var(--bg-color);

	&.bottom-bar {
		bottom: 0px;
		z-index: 60;
		position: absolute;
	}

	.empty-button-placeholder {
		width: $button-width !important;
	}

	.cancel-button {
		padding: 0px !important;
		height: 36px !important;
		width: $button-width !important;
		background: var(--page-background) !important;

		font-size: 14px !important;
		color: var(--primary-font-color) !important;
	}
}
</style>
